// Écran de saisie d'une Facture fournisseur (achat).
import React from "react";
import { ShoppingCart } from "lucide-react";
import SaisieFacture from "@/components/SaisieFacture";

export default function FactureFournisseur() {
  return (
    <SaisieFacture
      config={{
        typeFacture: "fournisseur",
        endpoint: "/factures/fournisseur",
        titre: "Facture fournisseur",
        sousTitre: "Enregistrez les factures reçues de vos fournisseurs.",
        icone: ShoppingCart,
        tiersLabel: "Fournisseur",
        selecteurTiersTestId: "facture-selecteur-fournisseur",
        pageTestId: "page-facture-fournisseur",
        descriptionPlaceholder: "Description de l'achat ou de la dépense",
        showReference: true,
        referenceLabel: "Référence fournisseur (facultatif)",
        journalCode: "AC",
        libelleJournal: "AC — Achats",
        compteTva: "445660",
      }}
    />
  );
}
